// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1_I5w","cls2":"Cta-cls2_kRb Cta-cls1_I5w"};